export default {
    abonplata: "Абонентська плата",
    absent: "Відсутній",
    access_restriction: "Обмеження доступу",
    accountant_fio: "ПІБ головного бухгалтера",
    accrue_bonuses_on_bonus_payments: "Нараховувати бонуси на оплату бонусами",
    acquiring_fee: "Комісія за оплату",
    activate_bonus_system: "Активувати бонусну систему",
    add_field: "Додати напрям",
    add_user: "Додати користувача",
    additional_doctors: "Додатково лікарів",
    additional_green_api: "Додатково green API",
    additional_green_api_max: "Додатково green API Max",
    additional_green_api_telegram: "Додатково green API Telegram",
    additional_jet_api: "Додатковий JET API",
    additional_modules: "Додаткові модулі",
    additional_partner_api: "Додатково партнерський api",
    additional_space: "Додаткове місце",
    admins_limit: "Ліміт адміністраторів",
    Advance: "Депозит",
    advance_calculated: "Депозит",
    advance_payment: "Одноразовий платіж",
    after_discounts: "Після урахування знижок",
    after_technic_deduction: "Після відрахування техніка",
    after_visit: "Нагадування після візиту",
    after_visit_day_passed: "Після візиту (відразу)",
    AgreementDocument: "Шаблон згоди",
    akt_text: "Позначка в акті наданих послуг",
    all_administrators: "Всі адміністратори",
    all_rights: "Всі права",
    all_visits: "Всі записи",
    allow: "Дозволити",
    allow_negative_deposits: "Дозволяти списання депозитів у мінус",
    allow_opening_several_visits_at_the_same_time: "Дозволити відкриття декількох візитів одночасно",
    allowed_ips: "IP адреси, з яких можливий вхід до облікового запису",
    api: "API",
    api_token: "API токен",
    are_you_sure_you_want_to_delete_branch: "Ви впевнені, що хочете видалити філію?",
    are_you_sure_you_want_to_delete_company: "Ви впевнені, що хочете видалити компанію?",
    are_you_sure_you_want_to_delete_notification: "Ви впевнені, що хочете видалити повідомлення?",
    are_you_sure_you_want_to_delete_source: "Ви впевнені, що хочете видалити джерело?",
    are_you_sure_you_want_to_delete_tag: "Ви впевнені, що хочете видалити позначку?",
    ask_for_more: "Запитати ще",
    ask_reason_cancel: "Запитувати причину при скасуванні візиту",
    ask_reason_not_come: "Запитувати причину при статусі 'не прийшов'",
    ask_reason_reschedule: "Запитувати причину перенесення візиту",
    assistants_connected: "Підключено модуль Помічники",
    automatic_conflict_task_creation: "Автоматичне створення завдань під час конфлікту розкладу",
    available_disk_space: "Доступне місце на диску, МБ (0 - безліміт)",
    before_discounts: "До урахування знижок",
    before_technic_deduction: "До відрахування техніка",
    before_visit: "Нагадування перед візитом",
    before_visit_day_in_advance: "Нагадування про візит за день (відразу)",
    billing: "Білінг",
    billing_payment: "Оплата",
    billing_turned_off: "Біллінг відключено",
    bonus: "Бонус",
    bonus_accrued: "Нараховано бонусів",
    bonus_adjustment: "Коригування бонусів",
    bonus_payment: "Оплата бонусом",
    bonus_percent_can_be_used: "Максимальна частка продажу, яку можна сплатити бонусами",
    bonus_percent_of_cheque: "Відсоток бонусів від продажу",
    bonus_system: "Бонусна система",
    bonuses: "Бонуси",
    bonuses_payment: "Оплата бонусами",
    branch_address: "Адреса філії",
    branch_contacts: "Контакти філії",
    branch_inn: "ІПН філії",
    branches: "Філії",
    branches_connected: "Підключено платний модуль Філії",
    by_chairs: "По кріслам",
    calendar_text_color: "Колір тексту в календарі",
    calendar_view_by_default: "Вид календаря за замовчуванням",
    cancel_and_move_reason: "Причина відміни та перенесення",
    cancel_and_move_reasons: "Причини відміни та перенесення",
    change_tariff: "Змінити тариф",
    cities: "Міста",
    city: "Місто",
    client_tag: "Позначка",
    ClientDocument: "Документ пацієнта",
    ClientNote: "Примітка",
    ClientTag: "Тег пацієнта",
    clinic: "Клініка",
    clinic_data: "Дані клініки",
    clinic_inn: "ІПН клініки",
    clinic_is_blocked: "Клініка заблокована",
    clinic_name: "Назва клініки",
    clinic_name_in_cheque: "Назва клініки в чеку",
    ClinicAdditional: "Дод. налаштування клініки",
    clinics: "Клініки",
    ClinicTariff: "Тариф клініки",
    close: "Закрити",
    cloud_space: "Місце в хмарі",
    communications: "Комунікації",
    company_data: "Дані компанії",
    ComplexService: "Комплексна послуга",
    configuration: "Конфігурація",
    connected_successfully: "Підключено успішно",
    connection_failed: "Помилка зв'язку",
    control_system: "Система контролю",
    countries: "Країни",
    country: "Країна",
    crm_application_created: "Створення заявки CRM",
    crm_connected: "Підключено платний модуль CRM",
    Curator: "Куратор",
    currency_rates: "Курси валют",
    CustomRole: "Роль",
    data: "Дані",
    date_of_registration: "Дата реєстрації",
    day: "День",
    deduct_acquiring_from_salary: "Відраховувати комісію за оплату зарплати",
    deduct_warranty_from_salary: "Не нараховувати зарплату працівникам з гарантійного випадку",
    deleted: "Видалення",
    demo: "Демо",
    DepositByAccount: "Депозит за рахунком",
    director_data: "Дані директора",
    director_fio: "ПІБ директора",
    disk_space_limit: "Ліміт дискового місця (Мб)",
    do_not_deduct_acquiring_from_technic_absolute: "Не віднімати еквайринг у техніків з абсолютним нарахуванням",
    do_not_send_notifications_if_period_passed: "Не надсилати нагадування про візит, якщо термін уже минув",
    do_not_show: "Не показувати",
    Doctor: "Лікар",
    'doctor-services': "Лікар - послуги",
    DoctorAssistant: "Асистент",
    doctors_limit: "Ліміт лікарів",
    DoctorScheduleConfiguration: "Налаштування розкладу лікаря",
    DogovorDocument: "Шаблон договору",
    DynamicConfig: "Конфігурація",
    egisz_prod: "ЕГІСЗ у бойовому режимі",
    EGISZRecord: "Відправка в ЄДІСОЗ",
    enter_ip_address: "Введіть IP-адресу",
    error_code: "Код помилки",
    field_configuration_in_diary: "Налаштування полів у щоденнику",
    field_configuration_in_teeth_general: "Налаштування загальних полів у вкладці зубів",
    field_configurations_in_description: "Настройка полів в описі",
    field_configurations_in_teeth: "Настройка полів в зубах",
    finance: "Фінанси",
    free: "Вільно",
    free_day: "Безплатний день",
    general: "Загальне",
    GeneratedDocument: "Сформований документ",
    has_additional_doctors: "Є додаткові лікарі",
    higher_number_higher_priority: "Чим вищий номер, тим вища опція у списку",
    hour: "година",
    hours: "години",
    image_hidden: "Зображення приховано",
    in_development: "У розробці",
    insurance_company: "Страхова компанія",
    integrations: "Інтеграції",
    interface: "Інтерфейс",
    ioka: "Ioka",
    ip_note: "Будьте уважні при введенні IP-адреси, щоб не втратити доступ до програми. Можна використовувати, якщо у Вас статична IP-адреса в клініці.",
    jetapi_connected: "Підключено модуль JET API",
    'kit materials sync': "Прив'язка матеріалів до комплекту",
    kpp: "КПП",
    last_login: "Останній вхід",
    legal_address: "Юридична адреса",
    legal_name: "Юридична назва",
    license: "Ліцензія",
    license_issue_body: "Ким видано ліцензію",
    license_issue_date: "Дата видачі ліцензії",
    license_num: "Ліцензія #",
    location_on_map: "Розташування на карті",
    logo: "Логотип",
    logout_interval_timeout: "Інтервал виходу з програми при відсутності активності (для облікових записів адміністраторів)",
    logs: "Логи",
    logs_journal: "Журнал дій",
    Manager: "Адміністратор",
    manager2: "Менеджер",
    manual: "Ручна",
    max_doctor_amount: "Максимальна кіл-ть лікарів",
    max_qr_instructions: "Прочитайте QR-код на телефоні в додатку Max",
    min: "хвилин",
    min_symbols: "Мінімум символів",
    minute: "хвилина",
    minutes: "хвилин",
    model_id: "Id моделі",
    model_type: "Тип моделі",
    month: "Місяць",
    monthly_payment: "Месячний платіж",
    months_to_consider_patient_lost: "Кількість місяців, після яких пацієнт вважається загубленим",
    more_than_one_day: "Більше одного дня",
    more_than_one_visit: "Більше одного візиту",
    next_payment: "Наступний платіж",
    not_connected: "Не підключено",
    notification_channel: "Тип доставки",
    notification_setting: "Повідомлення",
    notification_type: "Тип повідомлення",
    notifications: "Повідомлення",
    NotificationSetting: "Повідомлення",
    NotificationWaitingResponse: "Очікування підтвердження у повідомленні",
    occupied: "Зайнято",
    of_few_hours: "години",
    ogrn: "ЄДРПОУ",
    oid_ministry_rf: "OID Міністерства охорони здоров'я РФ",
    on: "Включено",
    on_pay_page: "На сторінку оплати",
    online_booking: "Онлайн-запис",
    online_booking_activate: "Активувати онлайн-запис",
    online_booking_categories: "Відображати категорії послуг",
    online_booking_feedbacks: "Активувати функціонал відгуків",
    online_booking_map: "Відображати карту філії",
    online_booking_max_days: "Максимальний період запису на днях",
    online_booking_path: "Шлях пацієнта онлайн запису",
    online_booking_time: "Бронювати час у календарі чи ні",
    only_after_accordance_with_trustme: "Тільки після узгодження з trustme.kz",
    only_after_payment_received: "Тілько при отриманні оплати від пацієнта",
    paid_functionality: "Оплатний функціонал",
    paid_till: "Оплачено до",
    paid_with_bonus: "Сплачено бонусами",
    partner_api_limit: "Ліміт безкоштовного партнерського API",
    Patient: "Пацієнт",
    patient_conditions: "Стан пацієнтів",
    patient_sources: "Джерела пацієнтів",
    PatientComment: "Коментар пацієнта",
    patients_import: "Імпорт пацієнтів",
    pay: "Сплатити",
    pay_methods: "Способи оплати",
    pay_methods_acquiring: "Способи оплати для передачі на еквайринг-термінал",
    pay_methods_cash: "Способи оплати, що відображаються як готівка",
    pay_system: "Платіжна система",
    payable: "Платний",
    Payment: "Оплата",
    payment_id: "Id оплати",
    percent_accrual_for_administrator: "Нарахування відсотка адміністраторам",
    percent_accrual_for_personnel: "Нарахування відсотка персоналу",
    period_by_default: "Період за замовчуванням",
    permanent_patients_hint: "Чи вважати пацієнта постійним при: а) наявності у нього мінімум двох візитів зі статусом прийшов або послугами в рахунку, навіть протягом одного дня; б) наявності у нього мінімум двох різних днів з візитами",
    plan_treatment_text: "Позначка щодо лікування",
    PlanSession: "Етап плану лікування",
    PlanTreatment: "План лікування",
    popup: "Попап",
    Price: "Позиція прайсу",
    price_per_additional_doctor: "Ціна за додаткового лікаря",
    price_per_additional_partner_api: "Ціна за додатковий affiliate api",
    price_per_additional_space: "Ціна за додаткове місце (100 Мб)",
    program_language: "Мова програми",
    prolong: "Продовжити",
    purchase: "Придбання",
    recipient: "Отримувач",
    Record: "Запис",
    record_tag: "Ярлик для візитів",
    record_tags: "Ярлики для візитів",
    record_timing_enabled: "Система контролю 'Початок та завершення візитів'",
    record_types: "Типи візитів",
    RecordTooth: "Зуб",
    reject: "Відхилити",
    required_fields_to_close_visit: "Обов'язкові поля для закриття візиту",
    requires_payment: "Потребує доплати",
    reset_verb: "Скинути",
    right: "Право",
    rights: "Права",
    salary_accrual: "Логіка нарахування процентів лікарям / адміністраторам / кураторам",
    salary_accrual_for_personnel: "Нарахуванняе зарплатні лікарям / адміністраторам / кураторам",
    salary_accrual_for_personnel_with_assistants: "Нарахування зарплати лікарям/адміністраторам/кураторам/асистентам",
    salary_accrual_for_technics: "Нарахуванняе зарплатні технікам",
    salary_accrual_with_assistants: "Логіка нарахування відсотків лікарям/адміністраторам/кураторам/асистентам",
    save_settings: "Зберегти налаштування",
    Scan: "Скан",
    send_time: "Час відправки",
    sending_after_save_or_finish: "Запросити результат візиту / виправку документа в ЄГІСЗ при написанні:",
    sendouts_only_in_day_time: "Надсилати масові розсилки в денний час (09.00 - 22.00)",
    server_error: "Системі не вдалося виконати ваш запит. Будь ласка, спробуйте ще раз або зверніться в службу підтримки",
    services_import: "Імпорт послуг",
    'services-doctor': "Послуги - лікар",
    short_title: "Коротка назва",
    show_complex_materials_for_teeth: "Відображати комплекти та матеріали у вкладці \"Зуби\" в Картці лікування",
    show_description_in_forms: "Відображати коментар до візиту до формату 043, 058, історії лікування",
    show_doctor_in_documents: "Покажіть лікаря під час друку документів",
    show_images: "Показувати зображення",
    show_preinstalled_templates: "Показувати попередньо встановлені шаблони",
    show_service_classificator_data_in_documents: "Використовуйте код і назву послуги в друкованих документах з класифікатора",
    show_teeth_general: "Відображати спільні поля у вкладці \"Зуби\" у Картці лікування",
    sign_type: "Тип підпису",
    sort_order: "Порядок сортування",
    source: "Джерело",
    sources: "Джерела",
    StaffWork: "Робота співробітника",
    super_user: "Суперкористувач",
    superadmin: "Суперадмін",
    superadministrators: "Суперадміністратори",
    supermanager: "Суперменеджер",
    SuperManager: "Адміністратор",
    switched_to_version_2: "Перейшла на версію 2.0",
    sync_data: "Синхронізувати дані",
    table_settings: "Сервірування столу",
    tag: "Ярлик",
    tag_id: "Мітка",
    tags: "Позначки",
    tags_for_custom_notifications: "Теги для автоматичного виведення інформації:",
    tags_for_notifications: "Теги для автоматичного виведення інформації:",
    tariff: "Тариф",
    tariff_payment_expires_in_days: "Оплата за тарифом закінчується сьогодні | Оплата за тарифом закінчується через {day} день | Оплата за тарифом закінчується через {day} дня",
    tariffs: "Тарифи",
    task_created: "Створення задачі",
    Technic: "Технік",
    technic_salary_accrual: "Логіка нарахування відсотків технікам",
    techsupport_panel: "Панель техпідтримки",
    templates: "Шаблони",
    templates_agreements: "Шаблони згод",
    templates_categories: "Стандартні категорії",
    templates_contracts: "Шаблони договорів",
    templates_for_fields: "Шаблони для полів",
    templates_text: "Шаблони текстів",
    templates_treatments: "Шаблони лікувань",
    test: "Тест",
    this_may_take_several_minutes_do_not_close_the_window: "Це може зайняти кілька хвилин. Не закривайте вікно",
    time_after_visit: "посля візиту",
    time_before_visit: "до візиту",
    time_interval_value: "Величина інтервалів часу",
    time_zone: "Часовий пояс",
    to_billing: "До налаштувань білінгу",
    to_the_one_who_accepted_payment: "Тому, хто приймає платіж",
    to_the_one_who_made_record: "Тому, хто робить запис",
    top: "Топ",
    treatment_finished: "Лікування завершено",
    turn_off: "Відключити",
    turn_on_autosign: "Увімкнути автопідпис",
    turned_off: "Вимкнена",
    turned_on: "Увімкнена",
    ukrainian: "Українска",
    unblock_for_3_days: "Розблокувати на 3 дні",
    updated: "Змінено",
    use_bonuses_on_salary: "Нарахування зарплати з оплати бонусами",
    use_proxy: "Использовать прокси",
    User: "Користувач",
    user_id: "Id користувача",
    UserAdditional: "Дод. дані користувача",
    uzbek: "Узбецький",
    verify: "Перевірити",
    'visit services sync': "Прив'язка послуг",
    visit_cancel: "Відміна візиту",
    visit_comment: "Коментар візиту",
    visit_created: "Створення візиту",
    visit_result: "Результат візиту",
    visit_results: "Результати візиту",
    visit_type: "Тип візиту",
    warehouse_connected: "Підключено платний модуль склад",
    WarehouseInventarizationSheet: "Інвентаризаційна відомість",
    WarehouseOperation: "Складська операція",
    week: "Тиждень",
    when_changing_tariff_all_payments_will_nullify: "При зміні тарифу всі платежі будуть анульовані",
    which_branches_use_online_booking: "Які філії використовують онлайн-запис",
    which_clients_to_consider_permanent: "Яких клієнтів вважати постійними",
    work_time_from: "Час роботи з",
    work_time_to: "Час роботи до",
    your_current_ip: "Ваш поточний IP",
    your_tariff_plan_is_not_paid: "Ваш тарифний план не сплачено",
    zero_unlimited: "0 - необмежено"
}
